import { render, staticRenderFns } from "./StaffInShifts.vue?vue&type=template&id=6a7de35a&scoped=true"
import script from "./StaffInShifts.vue?vue&type=script&lang=js"
export * from "./StaffInShifts.vue?vue&type=script&lang=js"
import style0 from "./StaffInShifts.vue?vue&type=style&index=0&id=6a7de35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7de35a",
  null
  
)

export default component.exports